
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ckan/hosting",
      function () {
        return require("private-next-pages/solutions/ckan/hosting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ckan/hosting"])
      });
    }
  